import { logoutUser } from '@helpers/auth.helper';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { LoadingDots } from '@shared/atoms';
import React, { useEffect } from 'react';

const LogoutPage: React.FunctionComponent = () => {
  const { isDesktop } = useWindowDimensions();
  useEffect(() => {
    const performLogout = async () => {
      await logoutUser();

      const { hostname } = window.location;

      if (hostname === 'wellbeing.flourish.co.uk') {
        window.location.replace('https://app.click-learning.co.uk/login');

        return;
      }

      if (hostname === 'beacon.laurahydefoundation.org') {
        window.location.replace('https://beacon.laurahydefoundation.org/login/beacon');

        return;
      }

      const searchParams = new URLSearchParams(window.location.search);
      const action = searchParams.get('action');

      if (action === 'logout') {
        window.location.replace('/login?action=logout');
      } else {
        window.location.replace('/login');
      }
    };

    performLogout();
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f7f2',
      }}
    >
      <LoadingDots size={isDesktop ? 24 : 20} isHapstarLoading dotCount={3} />
    </div>
  );
};

export default LogoutPage;
